import {
  IConsequence,
  IEvaluationCategoryApi,
  IIssueBoardApi,
  IMatrixConfig,
  IRisikoProbability,
} from "@mcapps/shared";
import { IIssueApi } from "@schemas/issueSchema";
import { ICapitalLetter } from "@schemas/otherAttributesSchema";
import { useEffect, useState } from "react";
import { getColor, getMatrixConfigFiltred, getScore } from "../../app/routes/issuesApp/issueUtils";
import "./RisikoMatrix.css";

interface IIssueRisikoMatrixProps {
  issue: IIssueApi;
  issueBoard: IIssueBoardApi;
  evaluationCategoryCapital: ICapitalLetter;
  afterTiltak?: boolean;
}

const IssueRisikoMatrix: React.FC<IIssueRisikoMatrixProps> = ({
  issue,
  issueBoard,
  evaluationCategoryCapital,
  afterTiltak = false,
}) => {
  const [consequences, setConsequences] = useState<IConsequence[]>([]);
  const [probabilities, setProbabilities] = useState<IRisikoProbability[]>([]);
  const [matrixConfig, setMatrixConfig] = useState<IMatrixConfig>([]);
  const [issueProbability, setIssueProbability] = useState<ICapitalLetter | undefined>(undefined);
  const [issueConsequence, setIssueConsequence] = useState<ICapitalLetter | undefined>(undefined);

  useEffect(() => {
    const _consequences: IConsequence[] = Object.entries(
      (issueBoard.risikoSection?.evaluationCategoriesConfig?.[evaluationCategoryCapital] as IEvaluationCategoryApi)
        ?.consequences ?? {},
    )
      .map(([key, value]) => {
        return value;
      })
      .filter((c) => c.isActive);

    const _probabilities: IRisikoProbability[] = Object.entries(issueBoard.risikoSection?.probabilites ?? {}).map(
      ([key, value]) => {
        return {
          ...value,
          id: key,
        };
      },
    );

    setConsequences(_consequences);
    setProbabilities(_probabilities.filter((p) => p.isActive));
    setMatrixConfig(getMatrixConfigFiltred(issueBoard, evaluationCategoryCapital));
    setIssueProbability(afterTiltak ? issue.risiko?.probabilityAfterTiltak : issue.risiko?.probability);
    const consequencesForMatrix = afterTiltak ? issue.risiko?.consequenceAfterTiltak : issue.risiko?.consequence;
    setIssueConsequence(consequencesForMatrix?.[evaluationCategoryCapital]);
  }, [afterTiltak, issue, issueBoard, evaluationCategoryCapital]);

  const consequenceOnXAxis = issueBoard.risikoSection?.consequenceOnXAxis === true;
  const matrixRows = consequenceOnXAxis ? [...probabilities].reverse() : consequences;
  const matrixColumns = consequenceOnXAxis ? consequences : probabilities;

  return (
    <div className="matrix-container">
      {matrixRows.map((rowItem, rowIndex) => (
        <div className="matrix-row" key={rowIndex}>
          {matrixColumns.map((columnItem, columnIndex) => {
            const consequence = consequenceOnXAxis ? columnItem : rowItem;
            const probability = consequenceOnXAxis ? rowItem : columnItem;
            const consequenceIndex = consequences.indexOf(consequence);
            const probabilityIndex = probabilities.indexOf(probability);
            const isIssueProbability = issueProbability === probability.id;
            const isIssueConsequnce = issueConsequence === consequence.id;
            const isScoreCell = isIssueProbability && isIssueConsequnce;

            return (
              <div
                key={columnIndex}
                className={`matrix-cell`}
                style={{ backgroundColor: getColor(probabilityIndex, consequenceIndex, matrixConfig) }}
              >
                {isScoreCell === true && <span className="score">{getScore(consequence, probability)}</span>}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default IssueRisikoMatrix;
